import apiEndpoints from 'const/apiEndpoints'
import api from 'services'

const postElectronicConsent = async (
  leadAccountId: string
): Promise<boolean> => {
  const econsentURL = `${apiEndpoints.ELECTRONIC_CONSENT}?cipher.accountId=${leadAccountId}&accountIdType=guid`

  const { data } = await api.post(econsentURL)

  const { econsentStatus } = data || {}

  return econsentStatus
}

export default postElectronicConsent
